import 'assets/css/common_reform.css'
import 'assets/css/keyword_reform.css'
import 'assets/css/override.css'
import { Redirect, Route, Switch } from 'react-router-dom'
import { useSelector } from 'react-redux'
import useLogin from 'features/login/useLogin'
import { LOGIN_STATUS } from 'features/login/loginConstants'
import useScrollTop from 'features/layout/useScrollTop'
import useTiaraTracker from 'utils/hooks/useTiaraTracker'
import ToastContainer from 'features/toast/ToastContainer'
import BackDrop from 'features/dialog/BackDrop'
import KakaoIndex from 'components/layout/KakaoIndex'
import KakaoWrap from 'components/layout/KakaoWrap'
import AppHeader from 'components/layout/AppHeader'
import Unauthorized from 'components/error/Unauthorized'
import InternalServerError from 'components/error/InternalServerError'
import ServiceUnavailable from 'components/error/ServiceUnavailable'
import OtpLogin from 'features/login/OtpLogin'
import AdAccountLayout from 'components/layout/AdAccountLayout'
import AppFooter from 'components/layout/AppFooter'
import BrowserAlert from 'components/layout/BrowserAlert'
import NotFound from 'components/error/NotFound'
import AdAccountListRedirect from 'features/crux/AdAccountListRedirect'
import BizAdAccountApp from 'features/crux/mfa/BizAdAccountApp'
import Dashboard from 'features/dashboard/Dashboard'
import AdManagementRoutes from 'features/ad/AdManagementRoutes'
import ReportList from 'features/report/ReportList'
import ReportAdd from 'features/report/ReportAdd'
import ChannelList from 'features/channel/list/ChannelList'
import ChannelAdd from 'features/channel/add/ChannelAdd'
import ChannelEdit from 'features/channel/edit/ChannelEdit'
import DocumentAdd from 'features/document/DocumentAdd'
import DocumentList from 'features/document/DocumentList'
import Tracker from 'features/crux/tracker/Tracker'
import RestrictionIpList from 'features/restrictionIp/RestrictionIpList'
import CreativeAdd from 'features/creative/add/CreativeAdd'
import CreativeListAndDetail from 'features/creative/CreativeListAndDetail'
import KeywordPlanner from 'features/keywordPlanner/KeywordPlanner'
import ImageList from 'features/image/ImageList'
import Bulk from 'features/bulk/Bulk'
import Editlog from 'features/editlog/Editlog'
import DashboardIdRedirect from 'features/dashboard/DashboardIdRedirect'
import DashboardRedirect from 'features/dashboard/DashboardRedirect'
import DocumentView from 'features/document/DocumentView'
import Jump from 'features/agency/Jump'
import MyInfo from 'features/myInfo/MyInfo'
import BizAdAccountDetailApp from './features/crux/mfa/BizAdAccountDetailApp'
import BizWalletDetailApp from './features/crux/mfa/BizWalletDetailApp'
import { useDashboardReset } from './utils/hooks/useDashboardReset'
import {
  LOUNGE_BOARD_ID_OFFSET,
  LOUNGE_BOARD_SERVICE_TYPE,
} from './features/loungeBoard/loungeBoardContants'
import LoungeBoardAlert from './features/loungeBoard/alert/LoungeBoardAlert'
import useLoungeBoardOptInPopup from './features/loungeBoard/optInPopup/useLoungeBoardOptInPopup'

const App = () => {
  useLogin()
  useScrollTop()
  useDashboardReset()
  useTiaraTracker()
  useLoungeBoardOptInPopup()
  const { loginStatus } = useSelector(state => state.login)
  return (
    ![LOGIN_STATUS.IDLE, LOGIN_STATUS.UNAUTHORIZED].includes(loginStatus) && (
      <>
        <KakaoIndex />
        <KakaoWrap>
          <AppHeader />
          <div id="kakaoMain" style={{ minHeight: '100%' }}>
            <main id="kakaoContent">
              <div id="mFeature" role="navigation" />
              <article id="mArticle">
                <Switch>
                  <Route exact path="/error/401" component={Unauthorized} />
                  <Route
                    exact
                    path="/error/500"
                    component={InternalServerError}
                  />
                  <Route
                    exact
                    path="/error/503"
                    component={ServiceUnavailable}
                  />
                  <Route exact path="/otp" component={OtpLogin} />
                </Switch>
                {loginStatus === LOGIN_STATUS.FAIL && (
                  <Redirect to="/error/500" />
                )}
                {loginStatus === LOGIN_STATUS.SUCCESS && (
                  <Switch>
                    <Route path="/:accountId(\d+)">
                      <AdAccountLayout>
                        <Switch>
                          <Route
                            path="/:accountId(\d+)/dashboard"
                            component={Dashboard}
                          />
                          <Route
                            path="/:accountId(\d+)/gotoDashboard"
                            component={DashboardIdRedirect}
                          />
                          <Route
                            path="/:accountId(\d+)/afterCreate"
                            component={DashboardRedirect}
                          />
                          <Route
                            path="/:accountId(\d+)/ads"
                            component={AdManagementRoutes}
                          />
                          <Route
                            exact
                            path="/:accountId(\d+)/report"
                            component={ReportList}
                          />
                          <Route
                            exact
                            path={[
                              '/:accountId(\\d+)/report/add',
                              '/:accountId(\\d+)/report/:domain/:reportId(\\d+)',
                            ]}
                            component={ReportAdd}
                          />
                          <Route
                            exact
                            path="/:accountId(\d+)/channels"
                            component={ChannelList}
                          />
                          <Route
                            exact
                            path="/:accountId(\d+)/channels/add"
                            component={ChannelAdd}
                          />
                          <Route
                            exact
                            path="/:accountId(\d+)/channels/:channelId(\d+)"
                            component={ChannelEdit}
                          />
                          <Route
                            path="/:accountId(\d+)/documents/add/:channelId(\d+)"
                            component={DocumentView}
                          />
                          <Route
                            path="/:accountId(\d+)/documents/add"
                            component={DocumentAdd}
                          />
                          <Route
                            path="/:accountId(\d+)/documents"
                            component={DocumentList}
                          />
                          <Route
                            path="/:accountId(\d+)/tracker"
                            component={Tracker}
                          />
                          <Route
                            path="/:accountId(\d+)/restrict-ip"
                            component={RestrictionIpList}
                          />
                          <Route
                            exact
                            path="/:accountId(\d+)/creatives/add/:creativeId(\d+)"
                            component={CreativeAdd}
                          />
                          <Route
                            path="/:accountId(\d+)/creatives/add"
                            component={CreativeAdd}
                          />
                          <Route
                            exact
                            path={[
                              '/:accountId(\\d+)/creatives',
                              '/:accountId(\\d+)/creatives/:creativeId(\\d+)',
                            ]}
                            component={CreativeListAndDetail}
                          />
                          <Route
                            path="/:accountId(\d+)/keyword-planner"
                            component={KeywordPlanner}
                          />
                          <Route
                            path="/:accountId(\d+)/images"
                            component={ImageList}
                          />
                          <Route
                            path="/:accountId(\d+)/bulks"
                            component={Bulk}
                          />
                          <Route
                            path="/:accountId(\d+)/editlog"
                            component={Editlog}
                          />
                          <Route
                            path="/:accountId(\d+)/settings/adaccount"
                            component={BizAdAccountDetailApp}
                          />
                          <Route
                            path="/:accountId(\d+)/settings/bizwallet"
                            component={BizWalletDetailApp}
                          />
                          <Redirect
                            from="/:accountId(\d+)/settings/cash"
                            to="/:accountId(\d+)/settings/bizwallet/cash"
                          />
                          <Redirect
                            from="/:accountId(\d+)/settings/paymentcard"
                            to="/:accountId(\d+)/settings/bizwallet/card"
                          />
                          <Redirect
                            from="/:accountId(\d+)/cash-receipts"
                            to="/:accountId(\d+)/settings/bizwallet/evidence"
                          />
                          <Route
                            path="/:accountId(\d+)/*"
                            component={NotFound}
                          />
                        </Switch>
                      </AdAccountLayout>
                    </Route>
                    <Route
                      exact
                      path="/noticeboard"
                      render={() => {
                        location.href = `${process.env.REACT_APP_LOUNGE_BOARD_HOST}/bulletin/list?serviceType=${LOUNGE_BOARD_SERVICE_TYPE}`
                      }}
                    />
                    <Route
                      exact
                      path="/noticeboard/:id(\d+)"
                      render={({ match: { params } }) => {
                        location.href = `${
                          process.env.REACT_APP_LOUNGE_BOARD_HOST
                        }/bulletin/${
                          Number(params.id) + LOUNGE_BOARD_ID_OFFSET
                        }?serviceType=${LOUNGE_BOARD_SERVICE_TYPE}`
                      }}
                    />
                    <Route exact path="/myinfo" component={MyInfo} />
                    <Route
                      exact
                      path="/jump/:accountId(\d+)"
                      component={Jump}
                    />
                    <Route path="/adaccount" component={BizAdAccountApp} />
                    <Route
                      exact
                      path={['/adAccounts', '/adAccounts/invite']}
                      component={AdAccountListRedirect}
                    />
                    <Redirect
                      from="/adAccounts/new"
                      to="/adaccount/all/create"
                    />
                    <Route exact path="/" component={AdAccountListRedirect} />
                    <Route path="*" component={NotFound} />
                  </Switch>
                )}
              </article>
            </main>
          </div>
          <AppFooter />
        </KakaoWrap>
        <BrowserAlert />
        <LoungeBoardAlert />
        <ToastContainer />
        <BackDrop />
      </>
    )
  )
}

export default App
